<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Пользователи</div>
            </div>
            <div class="panel-body pn">
                <per-pager v-bind:per-page="pagination.perPage"></per-pager>
                <table class="table table-striped table-hover datatables" id="clients_list" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>ФИО</th>
                            <th>Телефон</th>
                            <th>Дата рождения</th>
                            <th>Статус</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user, index) in users" v-bind:key="index">
                            <td>{{user.id}}</td>
                            <td>
                                <router-link :to="{name: 'users-edit', params: {id: user.id}}">
                                    {{user.firstName}} {{user.lastName}}
                                </router-link>
                            </td>
                            <td>{{user.phone}}</td>
                            <td>{{user.birthdayTimestamp | dateFormatTimestamp('dd.mm.yyyy')}}</td>
                            <td>
                                <span class="label" :class="{'label-success': user.status === true, 'label-danger': user.status === false}">
                                    {{user.status === true ? 'Активный' : 'Отключен'}}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <paginator v-bind="pagination"></paginator>
            </div>
        </div>
    </div>
</template>

<script>
    import User from "../../models/User";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../data/Paginator'),
            PerPager: () => import('../data/PerPager'),
        },
        beforeMount() {
            this.load();
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.load();
        },
        data() {
            return {
                isLoading: false,
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                users: [],
            };
        },
        watch: {
            'pagination.perPage': function(value) {
                this.setDefaultPerPage(value);
            },
        },
        methods: {
            load() {
                this.isLoading = true;
                const page = this.$route.query.page ? this.$route.query.page : 1;
                const perPage = this.$route.query['per-page'] ? this.$route.query['per-page'] : this.getDefaultPerPage();
                User.getList(page, perPage).then(({data, headers}) => {
                    this.setData(data, headers);
                    this.isLoading = false;
                });
            },
            getDefaultPerPage() {
                if (this.$store.state.template.perPages['users-list']) {
                    return this.$store.state.template.perPages['users-list'];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: 'users-list', value: value})
            },
            setData(users, headers) {
                this.users = users;
                this.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(headers['x-pagination-total-count']);
            }
        },
        metaInfo() {
            return {
                title: 'Пользователи - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>